import React from 'react';
import { Avatar } from 'antd';
import cx from 'classnames';

import { getFormattedUTCDate } from 'utils/dateUtils';
import { getAvatarContent, getFullName } from 'utils/personUtils';
import { HistoryResponseModel, HistoryTypeEnum } from 'api/adminApiClient';
import { ActivitiesSectionPageTypeEnum } from 'components/ActivitiesDetailsSection/enums';
import { getStageHistoryLogDescription } from 'components/ActivitiesDetailsSection/HistorySection/utils';
import { getHistoryRenewalRehireLabel } from 'utils/historyUtils';

import styles from '../HistoryCard.module.less';

type Props = {
  historyItem: HistoryResponseModel;
  className?: string;
  pageType: ActivitiesSectionPageTypeEnum;
};

export default function HistoryLogCreatedInfo(props: Props) {
  const { historyItem, className = '', pageType } = props;
  const { createdDate, firstName, lastName, type, id, details } = historyItem;

  const getCardHeadText = () => {
    switch (type) {
      case HistoryTypeEnum.RescindingTermination:
        return <span>Assignment termination history details</span>;
      case HistoryTypeEnum.Termination:
        return (
          <span>{getFullName(firstName, lastName)} scheduled termination</span>
        );
      case HistoryTypeEnum.Details:
        return <span>{getFullName(firstName, lastName)} updated info</span>;
      case HistoryTypeEnum.Stage:
        return (
          <span>{getStageHistoryLogDescription(historyItem, pageType)}</span>
        );
      case HistoryTypeEnum.Scheduler:
        return (
          <span>
            {getFullName(firstName, lastName)} scheduled financial rates update
          </span>
        );
      case HistoryTypeEnum.CustomerAgreement:
        return (
          <span>
            {getFullName(firstName, lastName)} confirmed no agreement is
            available for customer
          </span>
        );
      case HistoryTypeEnum.Integration:
        return <span>Sales Order was successfully created</span>;

      case HistoryTypeEnum.RenewalRehire:
        return (
          <span>
            {getFullName(firstName, lastName)}{' '}
            {getHistoryRenewalRehireLabel(details)}
          </span>
        );
    }
  };

  return (
    <div
      className={cx(styles.cardHead, className)}
      data-id={`card-history-${id}`}
    >
      <Avatar className={styles.cardHeadAvatar} size={24}>
        {getAvatarContent(firstName, lastName)}
      </Avatar>

      <div className={styles.cardHeadText}>
        {getCardHeadText()}

        {type !== HistoryTypeEnum.RescindingTermination && createdDate && (
          <span className={styles.cardHeadDate}>
            at {getFormattedUTCDate(createdDate)}
          </span>
        )}

        {type === HistoryTypeEnum.Integration && (
          <>
            {' '}
            <a
              href={historyItem.details?.salesOrderLink}
              target="_blank"
              rel="noreferrer"
            >
              {historyItem.details?.salesOrderLink}
            </a>
          </>
        )}
      </div>
    </div>
  );
}
